import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug = 'all' }: CategoryNavProps) {
  return (
    <section className="py-8 px-4 md:px-6 max-w-[1280px] mx-auto" aria-label="漫画分类导航">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-heading text-foreground-900 whitespace-nowrap">
          <strong>漫画分类</strong>
        </h2>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {categories.map((cat) => {
          const isActive = cat.slug === activeSlug;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
                isActive
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-800'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          );
        })}
      </div>
    </section>
  );
}